<div class="edit-main d-flex flex-column">
  <div class="header">
    <div class="top-header">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        class="pointer-cursor"
        (click)="navigateBack()"
      />
      <div>
        <p class="top-heading">
          <app-with-tooltip [showHelpCursor]="true">
            {{ this.sharedData.selectedBuilding.buildingName }}
          </app-with-tooltip>
        </p>
        <h2 class="modal-title text-center heading2">
          {{
            (this.sharedData.editMode.floor ? "EDIT_FLOOR" : "NEW_FLOOR")
              | translate
          }}
        </h2>
      </div>

      <img
        src="/assets/svg/ico-cross.svg"
        class="pointer-cursor"
        (click)="closeDialog()"
      />
    </div>

    <br />
    <p class="text-center heading1" *ngIf="floors.length === 0">
      {{
        (this.sharedData.editMode.floor ? "FLOOR_DETAILS" : "ADD_A_FLOOR")
          | translate
      }}
    </p>
  </div>

  <div class="modal-body">
    <div class="floors-list mb-2" *ngFor="let floor of floors">
      <app-modal-item-view
        *ngIf="floors.length !== 0"
        [imagesource]="floorimage"
        [title]="floor?.floorName"
        [description]="floor?.wingName"
        [arrowIcon]="false"
      >
      </app-modal-item-view>
    </div>

    <form
      [formGroup]="addFloorForm"
      #formDirective="ngForm"
      class="d-flex flex-column justify-content-between h-100"
    >
      <div class="form-group rounded-top form-container">
        <p class="text-left new-floor" *ngIf="floors.length !== 0">
          {{ "NEW_FLOOR_DETAILS" | translate }}
        </p>
        <mat-form-field appearance="fill" class="w-100 mb-2">
          <mat-label>{{ "FLOOR_NUMBER_OR_LETTER" | translate }}</mat-label>
          <input
            matInput
            [placeholder]="'ENTER_FLOOR_NUMBER' | translate"
            formControlName="floorName"
            autocomplete="off"
          />
          <mat-error
            *ngIf="addFloorForm?.controls?.floorName?.errors?.whitespace"
            >{{ "EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED" | translate }}</mat-error
          >
          <mat-error
            *ngIf="addFloorForm?.controls?.floorName?.errors?.required"
            >{{ "YOU_MUST_ENTER_FLOOR_NUMBER" | translate }}</mat-error
          >
          <mat-error
            *ngIf="addFloorForm?.controls?.floorName?.errors?.minlength"
            >{{ "YOU_MUST_ENTER_MIN_TWO_CHAR" | translate }}</mat-error
          >
          <mat-error
            *ngIf="addFloorForm?.controls?.floorName?.errors?.maxlength"
          >
            {{
              commonService.stringInterPolation(
                "MAXIMUM_OF_CHARACTERS" | translate,
                "16"
              )
            }}
          </mat-error>
          <mat-error>
            <span
              *ngIf="
                addFloorForm?.controls?.floorName?.errors
                  ?.alphaNumWithRequiredSpecialCharacters &&
                !addFloorForm?.controls?.floorName?.errors?.required &&
                !addFloorForm?.controls?.floorName?.errors?.whitespace &&
                !addFloorForm?.controls?.floorName?.errors?.minlength &&
                !addFloorForm?.controls?.floorName?.errors?.maxlength
              "
            >
              {{ "YOU_MUST_ENTER_VALID_FLOOR_NUMBER" | translate }}
            </span>

            <span
              *ngIf="
                addFloorForm?.controls?.floorName?.errors
                  ?.firstCharacterIsSpecialChar &&
                !addFloorForm?.controls?.floorName?.errors?.required &&
                !addFloorForm?.controls?.floorName?.errors?.whitespace &&
                !addFloorForm?.controls?.floorName?.errors?.minlength &&
                !addFloorForm?.controls?.floorName?.errors?.maxlength
              "
            >
              {{
                "FLOOR_NAME_SHOULD_NOT_START_WITH_SPECIAL_CHARACTER" | translate
              }}
            </span>
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-100 mb-2">
          <mat-label>{{ "WING_NAME_OPTIONAL" | translate }}</mat-label>
          <input
            matInput
            [placeholder]="'ENTER_WING_NAME' | translate"
            formControlName="wingName"
          />
          <mat-error>
            <span
              *ngIf="addFloorForm?.controls?.wingName?.errors?.whitespace"
              >{{ "EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED" | translate }}</span
            >
            <span *ngIf="addFloorForm?.controls?.wingName?.errors?.maxlength">
              {{
                commonService.stringInterPolation(
                  "MAXIMUM_OF_CHARACTERS" | translate,
                  "50"
                )
              }}
            </span>
            <span
              *ngIf="
                addFloorForm?.controls?.wingName?.errors?.entityName &&
                !addFloorForm?.controls?.wingName?.errors?.whitespace &&
                !addFloorForm?.controls?.wingName?.errors?.maxlength
              "
              >{{ "YOU_MUST_ENTER_VALID_WING_NAME" | translate }}</span
            >
          </mat-error>
        </mat-form-field>

        <ng-container *appHideAccess="commonAccessControl">
          <mat-form-field appearance="fill" class="w-100 mb-2">
            <mat-label>{{ accessPointCountLabel }}</mat-label>
            <input
              matInput
              [placeholder]="'NUMBER_OF_ACCESS_POINT_PER_FLOOR' | translate"
              formControlName="accessPointsCount"
              type="number"
              step="1"
              onkeydown="if(event.key==='.'){event.preventDefault();}"
              min="1"
              max="1000"
              autocomplete="off"
            />
            <mat-error
              *ngIf="
                this.addFloorForm?.controls?.accessPointsCount?.touched &&
                this.addFloorForm?.controls?.accessPointsCount?.errors?.required
              "
              >{{ "YOU_MUST_ENTER_ACCESSPPOINTS_PER_FLOOR" | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                this.addFloorForm?.controls?.accessPointsCount?.touched &&
                this.addFloorForm?.controls?.accessPointsCount?.errors?.min
              "
              >{{ "ACCESS_POINT_COUNT_SHOULD_BE_GREATER" | translate }}
              {{ this.previousData?.accessPointsCount }}.
            </mat-error>
            <mat-error
              *ngIf="
                this.addFloorForm?.controls?.accessPointsCount?.touched &&
                this.addFloorForm?.controls?.accessPointsCount?.errors?.max
              "
              >{{ "ACCESS_POINT_COUNT_BETWEEN_ONE_AND_THOUSAND" | translate }}
            </mat-error>
          </mat-form-field>
        </ng-container>

        <mat-form-field appearance="fill" class="w-100 mb-2">
          <mat-label>{{ unitCountLabel }}</mat-label>
          <input
            matInput
            max="1000"
            [placeholder]="'NUMBER_OF_UNITS_PER_FLOOR' | translate"
            formControlName="unitsCount"
            type="number"
            step="1"
            onkeydown="if(event.key==='.'){event.preventDefault();}"
            min="0"
            autocomplete="off"
          />
          <mat-error
            *ngIf="
              this.addFloorForm?.controls?.unitsCount?.touched &&
              this.addFloorForm?.controls?.unitsCount?.errors?.required
            "
            >{{ "YOU_MUST_ENTER_UNITS_PER_FLOOR" | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              this.addFloorForm?.controls?.unitsCount?.touched &&
              this.addFloorForm?.controls?.unitsCount?.errors?.min
            "
            >{{ "UNIT_COUNT_SHOULD_BE_GREATER" | translate }}
            {{ this.previousData?.unitsCount }}.
          </mat-error>
          <mat-error
            *ngIf="
              this.addFloorForm?.controls?.unitsCount?.touched &&
              this.addFloorForm?.controls?.unitsCount?.errors?.max
            "
            >{{ "UNIT_COUNT_BETWEEN_ZERO_AND_THOUSAND" | translate }}
          </mat-error>
        </mat-form-field>

        <div class="row d-flex justify-content-center align-items-center">
          <button
            type="button"
            class="add-button mb-4 w-100"
            (click)="onAddFlooHandler()"
            *ngIf="!this.sharedData.editMode.floor"
            [controlDisabled]="[PageName.Floor, CONSTANTS.CREATE]"
            [disabledCheck]="
              !addFloorForm.valid ||
              this.sharedData.editMode.floor ||
              this.localFloors?.length > config.MAX_FLOOR_LENGTH
            "
          >
            <strong> {{ "ADD_FLOOR" | translate }}</strong>
          </button>
          <button
            *ngIf="this.sharedData.editMode.floor"
            (click)="onRemoveFloor()"
            class="d-flex flex-row justify-content-center align-items-center d-none remove-btn"
            type="button"
            [controlDisabled]="[PageName.Floor, CONSTANTS.DELETE]"
          >
            <img src="assets/svg/ico-close-circle-outline.svg" />
            <p class="remove-floor ml-2 pt-2">
              {{ "REMOVE_FLOOR" | translate }}
            </p>
          </button>
        </div>
      </div>

      <input
        type="file"
        id="fileUploadBuilding"
        name="fileUploadBuilding"
        class="d-none"
      />

      <div class="row">
        <div class="col-12 my-1">
          <button
            class="btn btn-danger px-3 w-100 done-btn"
            type="button"
            tabindex="0"
            (click)="onDoneHandler()"
            [controlDisabled]="[PageName.Floor, CONSTANTS.CREATE]"
            [disabledCheck]="
              !addFloorForm.valid ||
              this.localFloors?.length > config.MAX_FLOOR_LENGTH
            "
          >
            {{ "DONE" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
